import { Collection } from "@/types/collection/collection";
import { Store } from "vuex";
import { namespace as collectionsNameSpace } from "../modules/collections/collections";

export class CollectionsStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    public async loadTree(): Promise<void> {
        return this.store.dispatch(`${collectionsNameSpace}/loadTree`);
    }

    /** Gets the collections tree  */
    public get collectionsTree(): Collection[] {
        return this.store.getters[`${collectionsNameSpace}/collectionsTree`];
    }

    /**
     * Gets a single collection
     * @param collectionId ID of the collection to find
     */
    public GetCollection(collectionId: number): Collection {
        return this.GetCollectionFromTree(this.collectionsTree, collectionId);
    }

    private GetCollectionFromTree(collections: Collection[], id: number): Collection {
        for (let i = 0; i < collections.length; i++) {
            if (collections[i].collection_id === id) return collections[i];
            if (collections[i].children && collections[i].children.length > 0) {
                const subCol = this.GetCollectionFromTree(collections[i].children, id);
                if (subCol) return subCol;
            }
        }
    }
}
